import OurProductsPage from '@modules/professional/page/OurProductsPage';
import { loader } from '@modules/professional/page/loaders/our-products-page-loader.server';
import { prefetchCategoryImages } from '~/modules/category/util/prefetch-category-images';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import type { SearchResultItem, SearchResults } from '~/modules/search';
import { mergeMeta } from '~/modules/seo';
import type { APHandle } from '~/modules/root';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data } = props;
        const isDesktop = data?.deviceType === 'desktop';
        const preloadImages = data?.searchResult?.hits
            ? prefetchProfessionalProductsImages(
                  data.searchResult.hits,
                  isDesktop
              )
            : [];
        return [...preloadImages];
    }
);

export const prefetchProfessionalProductsImages = (
    hits: SearchResults<SearchResultItem>['hits'],
    isDesktop: boolean
) => {
    const numberTilesToPreload = isDesktop ? 4 : 2;
    return prefetchCategoryImages(
        hits,
        numberTilesToPreload,
        getImagesSizes({ desktop: 348, mobile: 204 }),
        !isDesktop
    );
};

export const handle: APHandle = {
    category: 'product',
    excludedQuickSorts: ['uncategorised', 'newlyCreated', 'invalidLink'],
    hideContactArchiPro: true,
};

export { loader };
export default OurProductsPage;
